import { useMainStore } from '@/stores/mainStore'
import * as Sentry from '@sentry/vue'
import _mixpanel from 'mixpanel-browser'
import Vue from 'vue'

export function errorAlert(
  message: string,
  color = 'error',
  multiline = false,
  timeout = 5000
) {
  const mainStore = useMainStore()
  mainStore.alert = { message, color, multiline, timeout, active: true }
}

export function mixpanel(event: string, parameters?: Record<string, any>) {
  const NODE_ENV = import.meta.env.VITE_NODE_ENV
  if (window.location.pathname.includes('/placement')) {
    console.log('no mixpanel because of placement')
    return
  }

  if (NODE_ENV !== 'production') {
    console.log('firing mixpanel stage_', event, 'with params: ', parameters)
    _mixpanel.track('stage_' + event, parameters)
  } else {
    console.log('firing mixpanel', event, 'with params: ', parameters)
    _mixpanel.track(event, parameters)
  }
}

export function alert(
  message: string,
  color = 'success',
  multiline = false,
  timeout = 5000
) {
  const mainStore = useMainStore()
  mainStore.alert = { message, color, multiline, timeout, active: true }
}

export function initSentry() {
  Sentry.init({
    Vue,
    dsn:
      'https://9f12bf7d43ee4e4dbf602e0d6bb2ab36@o121000.ingest.sentry.io/4505603395747840',
    integrations: [
      new Sentry.Replay({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        networkDetailAllowUrls: [
          'localhost',
          'api.codewizardshq.com',
          'api.cwhqstage.com',
          'enroll-api.codewizardshq.com',
        ],
      }),
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.VITE_NODE_ENV,
    release: import.meta.env.VITE_GIT_VERSION,
  })
}

export function getImgSrc(imgSrc: string) {
  return new URL(`../assets/${imgSrc}`, import.meta.url).href
}

export function camelCase(str: string) {
  return str.split('-').reduce((a, b) => a + b.charAt(0).toUpperCase() + b.slice(1))
}
